import React, { useEffect } from "react";
import Avatar from "../../../assets/img/Anonymous.png";
import { useCreateEventState } from "../../../context/CreateEventContext";
import { useAuthentication } from "../../hooks/useAuthentication";
import { mergeData } from "../../PojedinaPrijavnica/PrijavnicaContainer/components/TablicaPolaznik/utils";
import { deleteEvidentionData } from "../api/deleteEvidentionDataForUser";
import "./TablePolaznici.css";
function RenderTableData({ data = [], intensiveId, externalUsers }) {
  const { authToken } = useAuthentication();
  const [mergedData, setMergedData] = React.useState([]);
  const { createEventData, updateCreateEventData } = useCreateEventState();
  const deletePolaznik = async (id) => {
    updateCreateEventData({
      ...createEventData,
      polazniciData: createEventData.polazniciData?.filter(
        (item) => item.id !== id
      ),
    });
    await deleteEvidentionData(id, intensiveId, authToken);
  };
  useEffect(() => {
    mergeData(externalUsers, setMergedData, data);
  }, [externalUsers, data]);
  return (
    <>
      {mergedData?.map((polaznik, index) => (
        <tr key={index}>
          <td style={{ color: "#2E3646", padding: "20px 12px" }}>
            <div className="table-polaznici-row">
              <div className="table-polaznici-avatar">
                <img
                  alt=""
                  src={polaznik?.imageUrl ? polaznik?.imageUrl : Avatar}
                />{" "}
              </div>
              {polaznik?.firstName ? polaznik?.firstName : "Vanjski"}{" "}
              {polaznik?.lastName ? polaznik?.lastName : "sudionik"}
            </div>
          </td>
          <td style={{ color: "#5F6D7E" }}>
            {polaznik?.aktivniProgramResponse.length > 0 ? (
              <div className="table-polaznici-column">
                {polaznik?.aktivniProgramResponse[0] && (
                  <>
                    <p style={{ marginBlockEnd: 5, marginBlockStart: 5 }}>
                      {polaznik?.aktivniProgramResponse[0].title}
                    </p>
                    <p style={{ marginBlockEnd: 5, marginBlockStart: 5 }}>
                      {polaznik?.aktivniProgramResponse[0].name}
                    </p>
                  </>
                )}
              </div>
            ) : (
              "Nema podataka"
            )}
          </td>
          <td style={{ color: "#5F6D7E" }}>
            {polaznik?.emailAddress ? (
              <p>{polaznik?.emailAddress}</p>
            ) : (
              "Nema podataka"
            )}
          </td>
          <td style={{ color: "#5F6D7E" }}>
            <div className="table-polaznici-row">
              {polaznik?.mobitel ? <p>{polaznik?.mobitel}</p> : "Nema podataka"}
              {polaznik?.id !== null && (
                <button
                  className="table-polaznici-button"
                  onClick={async () => await deletePolaznik(polaznik.id)}
                />
              )}
            </div>
          </td>
        </tr>
      ))}
    </>
  );
}

export default RenderTableData;
